import React, { useState } from 'react';
import { Box } from 'reflexbox';

import { Switch, Route } from '@treams/treams-routes';

import LearningEventsContainer from 'packages/kakapo-ui-application/pages/learning/pages/LearningEventsContainer';
import Container from 'packages/kakapo-ui-kit/components/grid/Container';
import LearningCalendarContainer from 'packages/kakapo-ui-application/pages/learning/pages/LearningCalendarContainer';

import LearningHeader from '../components/LearningHeader';

import LearningEventProposalsContainer from './LearningEventProposalsContainer';
import LearningMyEventsContainer from './LearningMyEventsContainer';
import LearningCertificatesContainer from './LearningCertificatesContainer';

import LearningEventModal from 'packages/kakapo-ui-application/pages/learning/pages/LearningEventModal';
import LearningEventAttendeesModal from 'packages/kakapo-ui-application/pages/learning/pages/LearningEventAttendeesModal';
import LearningEventEditModalID, {
	LearningEventEditModal as LearningEventCreateModal,
	default as LearningEventEditModal,
} from 'packages/kakapo-ui-application/pages/learning/pages/LearningEventEditModal';
import LearningEventAwardCertificatesModalID from './LearningEventAwardCertificatesModal';
import { useLocation } from 'react-router-dom';

type RouteParams = {
	id: string;
};

export function LearningRouterWithoutSidebar() {
	const location = useLocation();

	const [fetchKey, setFetchKey] = useState(0);

	return (
		<Container>
			<Box mb={[4, 4, 5]}>
				<LearningHeader />
			</Box>

			<Box mt={4}>
				<Switch>
					<Route path="/learning/event/create">
						<LearningEventCreateModal refetch={() => setFetchKey(Math.random())} />
					</Route>

					<Route<{ eventID: string }> path="/learning/events/copy?eventID=:eventID">
						{({ match }) =>
							match && <LearningEventEditModalID eventID={match.params.eventID!} copy />
						}
					</Route>

					<Route<RouteParams> path="/learning/event/:id/award-certificates" exact>
						{({ match }) =>
							match && <LearningEventAwardCertificatesModalID eventID={match.params.id!} />
						}
					</Route>

					<Route<RouteParams> path="/learning/event/:id/attendees" exact>
						{({ match }) => match && <LearningEventAttendeesModal eventID={match.params.id!} />}
					</Route>

					<Route<RouteParams> path="/learning/event/:id/edit" exact>
						{({ match }) => match && <LearningEventEditModal eventID={match.params.id!} />}
					</Route>

					<Route<RouteParams> path="/learning/event/:id" exact>
						{({ match }) => match && <LearningEventModal eventID={match.params.id!} />}
					</Route>
				</Switch>

				<Switch location={location.state?.backgroundLocation ?? location}>
					<Route path="/learning/calendar">
						<LearningCalendarContainer key={fetchKey} />
					</Route>

					<Route path="/learning/me" exact>
						<LearningMyEventsContainer key={fetchKey} />
					</Route>

					<Route path="/learning/certificates" exact>
						<LearningCertificatesContainer key={fetchKey} />
					</Route>

					<Route path="/learning/proposals" exact>
						<LearningEventProposalsContainer key={fetchKey} />
					</Route>

					<Route path="/learning">
						<LearningEventsContainer key={fetchKey} />
					</Route>
				</Switch>
			</Box>
		</Container>
	);
}
